import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-741bbe00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "q-pa-md" }
const _hoisted_3 = {
  key: 0,
  class: "col"
}
const _hoisted_4 = {
  key: 0,
  class: "q-py-md"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "q-mt-sm" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_info_box = _resolveComponent("info-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_inner_loading, { showing: _ctx.currentStepLoading }, {
      default: _withCtx(() => [
        _createVNode(_component_q_spinner, {
          color: "primary",
          size: "5em"
        }),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('STEP_3.CREATING', { objects: _ctx.t(`${_ctx.objectKey}.CAP.PLUR`) })), 1)
      ]),
      _: 1
    }, 8, ["showing"]),
    (!_ctx.previousStepLoading || _ctx.done)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.errorsContainsWarning.length || _ctx.errorIsNotWarning || _ctx.done)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), _toDisplayString(_ctx.t('STEP_3.IMPORTED_FILE')), 17),
                _createVNode(_component_iap_chip, {
                  class: "imported-file-chip",
                  "non-interactive": "",
                  tooltip: "",
                  icon: _ctx.ICONS_NAME.FILE_OUTLINE,
                  label: _ctx.fileUploaded
                }, null, 8, ["icon", "label"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _mergeProps({ class: "q-pb-lg" }, _ctx.TEXT_CONTENT_BODY3), [
            (_ctx.listToImport)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.subheader), 1),
                  (_ctx.meetingCompaniesInfo && _ctx.done)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.meetingCompaniesInfo), 1))
                    : _createCommentVNode("", true),
                  (_ctx.meetingContactsInfo && _ctx.done)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.meetingContactsInfo), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 16),
          (_ctx.errorsContainsWarning.length)
            ? (_openBlock(), _createBlock(_component_info_box, {
                key: 1,
                class: "q-mb-md",
                pattern: _ctx.InfoBoxPatternKey.WARNING,
                title: _ctx.warningTitle
              }, {
                "more-info": _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsListInParsing, (error, index) => {
                    return (_openBlock(), _createBlock(_component_q_item_label, _mergeProps({ class: "q-mt-sm" }, _ctx.TEXT_SMALL_BODY, { key: index }), {
                      default: _withCtx(() => [
                        (_ctx.errorIsWarning(error.representations.en))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.getErrorType(error.representations.en)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1040))
                  }), 128))
                ]),
                _: 1
              }, 8, ["pattern", "title"]))
            : _createCommentVNode("", true),
          (_ctx.errorIsNotWarning)
            ? (_openBlock(), _createBlock(_component_info_box, {
                key: 2,
                pattern: _ctx.InfoBoxPatternKey.DANGER,
                title: _ctx.alertTitle
              }, {
                "more-info": _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorsListInParsing, (error, index) => {
                      return (_openBlock(), _createBlock(_component_q_item_label, _mergeProps(_ctx.TEXT_SMALL_BODY, { key: index }), {
                        default: _withCtx(() => [
                          (!_ctx.errorIsWarning(error.representations.en))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.getErrorType(error.representations.en)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1040))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["pattern", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}